export default __webpack_public_path__ + "static/media/dieppe24.e98eed32.jpg";